import React from 'react';
import './styles.css';

/* import { Button } from 'semantic-ui-react';
import {
  faCloud,
  faBolt,
  faCloudRain,
  faCloudShowersHeavy,
  faSnowflake,
  faSun,
  faSmog,
} from '@fortawesome/free-solid-svg-icons'; */


import { 
    WiDayThunderstorm,
    WiDaySprinkle,
    WiDayRain,
    WiDaySnow,
    WiDaySunny,
    WiCloudy,
    WiCloud,
    WiThermometer, 
    // WiThermometerExterior,
    WiHumidity,
    WiBarometer,
    WiStrongWind


} from 'weather-icons-react';

//import styled from 'styled-components';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';



const translations = {
  en: {
    lHum: "Moist.:",
    lViento: "Wind:",
    lPA: "Atm.Press.:",
  },
  es: {
    lHum: "Hum.:",
    lViento: "Viento:",
    lPA: "Pres.Atm.:",
  }
};


export default function Weather({weatherData}) {
  

  const {language} = useSelector( state => state.data); 
  const t = translations[language];

  let weatherIcon = null;
  const sizeIcon = 48;
  const colorIcon = '#0A8013'
  //console.log({weatherData});
  //console.log({city});

  if (weatherData.current.weather[0].main === 'Thunderstorm') {
    weatherIcon = <WiDayThunderstorm size={sizeIcon} color={colorIcon} />;
  } else if (weatherData.current.weather[0].main === 'Drizzle') {
    weatherIcon = <WiDaySprinkle size={sizeIcon} color={colorIcon} />;
  } else if (weatherData.current.weather[0].main === 'Rain') {
    weatherIcon = <WiDayRain size={sizeIcon} color={colorIcon} />;
  } else if (weatherData.current.weather[0].main === 'Snow') {
    weatherIcon = <WiDaySnow size={sizeIcon} color={colorIcon} />;
  } else if (weatherData.current.weather[0].main === 'Clear') {
    weatherIcon = <WiDaySunny size={sizeIcon} color={colorIcon} />;
  } else if (weatherData.current.weather[0].main === 'Clouds') {
    weatherIcon = <WiCloudy size={sizeIcon} color={colorIcon} />;
  } else {
    weatherIcon = <WiCloud size={sizeIcon} color={colorIcon} />;
  }

  return (
 
      
      <div className="flexCurrentWeather">
                
           
            
                <span style={{ display: 'flex', padding: '2px', flexDirection: 'column' }}>
                    <div className="flextemp">
                        <span> {Number(weatherData.current.temp).toFixed(1)} <sup>&deg;</sup>C </span> 
                        {/* <p className="info">Sensación térmica: {Number(weatherData.current.feels_like).toFixed(0)} <sup>&deg;</sup></p>
                        */}
                    </div> 

                    <span className="spanInfo">
                      <WiThermometer size={26} color='#11266d' />
                        <span>
                            <div className="infoGreen">{Number(weatherData.daily[0].temp.max).toFixed(0)}<sup>&deg;</sup>C</div>
                            <div className="infosmall">Max.</div>
                        </span>
                        
                        <span>
                            <div className="infoGreen">  {Number(weatherData.daily[0].temp.min).toFixed(0)}<sup>&deg;</sup>C </div>
                            <div className="infosmall">Min.</div>
                        </span>
                    </span>
                     
                    {/* <p className="temp">Humidity: {weatherData.current.humidity} %</p> */}
                </span>


                
            
            
            
            <span style={{ display: 'flex', padding: '2px', flexDirection: 'column', alignItems: 'center' }}>
               
                  {weatherIcon}
                
                <div className="icontext">
                  {weatherData.current.weather[0].description}
                </div>
                
            </span>
           



            <span >
            
                
                
                
                <span className="spanInfo">
                    <WiHumidity size={24} color='#11266d' />
                    <div className="info"> {t.lHum} </div>
                    <div className="infoGreen"> {weatherData.current.humidity} %</div>
                </span>
                <span className="spanInfo">
                    <WiStrongWind size={24} color='#11266d' />
                    <div className="info"> {t.lViento} </div>
                    <div className="infoGreen"> {weatherData.current.wind_speed} Km/h</div>
                </span>
                <span className="spanInfo">
                    <WiBarometer size={24} color='#11266d' />
                    <div className="info"> {t.lPA} </div>
                    <div className="infoGreen">{weatherData.current.pressure} KPa</div>
                </span>
            
            
            </span>
      </div>
      

      
    
 
  )
}

Weather.propTypes = {
    weatherData: PropTypes.object.isRequired,
    
  }